export class CryptoXOR {

	private key: string;

	private generateRandomKey(): string {
		const array = new Uint8Array(16);
		crypto.getRandomValues(array);
		return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
	};

	private createCookie() {
		const expires = new Date();
		expires.setTime(expires.getTime() + 1000 * 60 * 60); // 1 hour
		document.cookie = `vue-ab-test=${this.generateRandomKey()}; expires=${expires.toUTCString()}; path=/`;
	}

	// Legge il cookie e restituisce il valore
	// Se il cookie è scaduto non lo trova perché il browser lo cancella in automatico
	private readCookie(): string {
		const name = 'vue-ab-test=';
		const decodedCookie = decodeURIComponent(document.cookie);
		const ca = decodedCookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}
		return '';
	}

	constructor() {
		
		let key = this.readCookie();
		if (!key) {
			this.createCookie();
			key = this.readCookie();
		}

		this.key = key;
	}

	private xorEncrypt(text: string): string {
		let result = "";
		for (let i = 0; i < text.length; i++) {
			result += String.fromCharCode(text.charCodeAt(i) ^ this.key.charCodeAt(i % this.key.length));
		}
		return btoa(result);
	}

	private xorDecrypt(encryptedText: string): string {
		let decoded = atob(encryptedText);
		let result = "";
		for (let i = 0; i < decoded.length; i++) {
			result += String.fromCharCode(decoded.charCodeAt(i) ^ this.key.charCodeAt(i % this.key.length));
		}
		return result;
	}

	// Metodi pubblici per criptare e decriptare
	encrypt(data: any): string {
		return this.xorEncrypt(JSON.stringify(data));
	}

	decrypt(data: string): Record<string, any> {
		try {
			return JSON.parse(this.xorDecrypt(data)) || {};
		} catch {
			return {};
		}
	}
}
